import BusinessDataIcon from '@resources/icons/BusinessDataIcon.svg?react';
import {
  OpenWidgetCommand,
  TeiaViewer,
  TeiaViewerSourceType,
  ToolbarItem,
  useTeiaSource,
  useViewerContext,
  useViewerSelection,
  useWidgetInfo,
} from '@stereograph/teiaviewer';
import { usePluginTranslation } from '@translation';

export const ShowTeiaOpenDataWidget = () => {
  const { t } = usePluginTranslation();
  const { viewer } = useViewerContext<TeiaViewer>();
  const twin = useTeiaSource(TeiaViewerSourceType.Twin);
  const { selection } = useViewerSelection();
  const { isOpened } = useWidgetInfo('TeiaOpenData');

  const onClick = () => {
    const command = new OpenWidgetCommand(viewer, 'TeiaOpenData');
    command.execute();
  };

  return (
    <ToolbarItem
      hidden={!twin}
      icon={BusinessDataIcon}
      onClick={onClick}
      disabled={selection.length === 0}
      label={t('toolbar.open_data.tooltip')}
      data-dd-action-name="toolbar.open_data"
      active={isOpened}
    />
  );
};
